<div class="outer-container" [ngClass]="{'tone-positive' : tone === VituToastTone.Positive, 'tone-negative' : tone === VituToastTone.Negative, 'tone-neutral' : tone === VituToastTone.Neutral, 'has-button': !!buttonText }">

  <div class="icon-container" [ngClass]="{'tone-positive' : tone === VituToastTone.Positive, 'tone-negative' : tone === VituToastTone.Negative, 'tone-neutral' : tone === VituToastTone.Neutral}">

    @switch (tone) {
      @case (VituToastTone.Positive) {
        <i class="fas fa-check-circle"></i>
      }
      @case (VituToastTone.Negative) {
        <i class="fas fa-exclamation-circle"></i>
      }
      @default {
        <i class="far fa-comment"></i>
      }
    }

  </div>

  <div class="text-container">
    @for (textLine of text; track textLine) {
      <div class="text-line">
        {{ textLine }}
      </div>
    }
  </div>

  @if (buttonText) {
    <div class="button-container">
      <lib-action-button
        [kind]="ActionButtonKind.ALERT"
        [alertTone]="alertTone"
        largeButton
        [label]="buttonText"
        (click)="onButtonClick()">
      </lib-action-button>
    </div>
  }

</div>
